import { Link } from "react-router-dom";
import { C, EHL_LOGO, NEXA_LOGO } from "../data/content";

export const Footer = ({ copyright = C.copyright }) => (
  <footer className="relative pt-32 pb-10 px-6 lg:px-12 overflow-hidden border-t border-white/[0.06]" data-testid="footer-section">
    <div className="footer-wordmark absolute bottom-24 left-1/2 -translate-x-1/2 pointer-events-none">
      VETERAN FAST-TRACK
    </div>
    <div className="relative max-w-[1200px] mx-auto">
      <div className="grid md:grid-cols-3 gap-10 text-[12px] text-white/45 leading-relaxed">
        <div data-testid="footer-legal-col">
          <img src={NEXA_LOGO} alt="NEXA Lending" className="h-12 w-auto invert opacity-90 mb-5" data-testid="footer-nexa-logo" />
          <p className="font-bold text-white/70 mb-3">{C.hostName}</p>
          <p>{C.hostCompany}</p>
          <p>NMLS# {C.hostNmls}</p>
          <p>Company NMLS# {C.hostCompanyNmls}</p>
          <p>Licensed in {C.hostLicenseStates}</p>
        </div>
        <div data-testid="footer-contact-col">
          <p className="font-bold text-white/70 mb-3">Contact</p>
          <p><a href="tel:4075505795" className="hover:text-white/70 transition-colors">Phone: 407-550-5795</a></p>
          <p><a href="mailto:dgussick@nexalending.com" className="hover:text-white/70 transition-colors">Email: dgussick@nexalending.com</a></p>
          <p><a href="https://webinar.darrengussick.com/" target="_blank" rel="noreferrer" className="hover:text-white/70 transition-colors">Website: webinar.darrengussick.com</a></p>
        </div>
        <div data-testid="footer-links-col">
          <p className="font-bold text-white/70 mb-3">Legal</p>
          <p><Link to="/privacy" className="hover:text-white/70 transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link></p>
          <p><Link to="/terms" className="hover:text-white/70 transition-colors" data-testid="footer-terms-link">Terms &amp; Conditions</Link></p>
        </div>
      </div>
      <div className="mt-14 pt-8 border-t border-white/[0.06] flex flex-col md:flex-row gap-6 items-start">
        <img src={EHL_LOGO} alt="Equal Housing Lender" className="w-12 h-auto opacity-70 shrink-0" data-testid="footer-ehl-logo" />
        <div>
          <p className="text-[11px] text-white/35 leading-relaxed max-w-[900px]" data-testid="footer-compliance">{C.compliance}</p>
          <p className="mono text-[10px] text-white/20 mt-6" data-testid="footer-copyright">{copyright}</p>
        </div>
      </div>
    </div>
  </footer>
);

export const StickyCTA = ({ label = "✓ RESERVE MY FREE SEAT", target = "register" }) => (
  <div className="sticky-cta fixed bottom-0 left-0 right-0 z-50 p-3 md:hidden" data-testid="mobile-sticky-cta">
    <button className="btn-accent w-full cta"
      onClick={() => document.getElementById(target)?.scrollIntoView({ behavior: "smooth" })}>
      {label}
    </button>
  </div>
);
